import { lazy } from "react";

/*const Home = lazy(() => import('./pages/Home'));
const Contact = lazy(() => import('./pages/Contact'));
const NotFound = lazy(() => import('./pages/NotFound'));
const Programmes = lazy(() => import('./pages/Programmes'));
const Syllabus = lazy(() => import('./pages/Syllabus'));
const Course = lazy(() => import('./pages/Course'));*/

import Home from "./pages/Home";
import Qnm from "./pages/Qnm";

const pageList = [
  { name: "Home", path: "/", component: Home },
  { name: "Qnm", path: "/qnm/:id/:code", component: Qnm },
  { name: "Qlm", path: "/qlm/:id/:code", component: Qnm },
  { name: "SSR", path: "/:id/:code", component: Qnm },
];
export default pageList;
